import Swal from "sweetalert2";

const showToast = (
  title: string,
  icon: "success" | "error" | "warning" | "info" | "question" = "success"
) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title,
    showConfirmButton: false,
    timer: 7000,
    showCloseButton: true,
    // timerProgressBar: true,
  });
};

export const toastSuccess = (msg: string) => showToast(msg, "success");
export const toastError = (msg: string) => showToast(msg, "error");
export const toastInfo = (msg: string) => showToast(msg, "info");
export const toastWarning = (msg: string) => showToast(msg, "warning");
